import { create } from 'zustand';
export const economyStore = create()(() => ({
    coins: 0,
    gems: 0,
}));
